// removed by extract-text-webpack-plugin
module.exports = {"PositionStatement":"PositionStatement","TabTable":"TabTable","TabContent":"TabContent","tab-pane":"tab-pane","PositionStatementTab":"PositionStatementTab","PositionStatementFilter":"PositionStatementFilter","AccountDropdown":"AccountDropdown","PositionStatementQuery":"PositionStatementQuery","PositionStatementBoard":"PositionStatementBoard","SheetData":"SheetData","ag-root":"ag-root"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/PositionStatement/styles.scss
// module id = 2272
// module chunks = 10